<script lang="ts" setup="">
import { computed } from 'vue';
import { CONFIRMATION_TYPE, type FormFragment } from '@pkg/sanity-utils/types/forms';
import { resolveConfirmationType } from '@pkg/sanity-utils/forms/resolveConfirmationType';
import PortableEditor from '@pkg/portable-text-editor/web/PortableEditor.vue';

const props = defineProps<{
  confirmation?: FormFragment['confirmation'];
  modularRenderer: any;
}>();

const { $i18n } = useNuxtApp();
const t = $i18n.t;

const confirmationType = computed(() => resolveConfirmationType(props.confirmation));

const messageContent = computed(() => confirmationType.value === CONFIRMATION_TYPE.MESSAGE ? props.confirmation?.contentMessage : undefined);
const contentBlocks = computed(() => confirmationType.value === CONFIRMATION_TYPE.BLOCKS ? props.confirmation?.contentBlocks : undefined);
const redirectConfirmation = computed(() =>
  confirmationType.value === CONFIRMATION_TYPE.REDIRECT
  || confirmationType.value === CONFIRMATION_TYPE.AUTOMATED_REDIRECT,
);
</script>

<template>
  <div>
    <PortableEditor v-if="messageContent" :content="messageContent" />
    <component :is="props.modularRenderer" v-if="contentBlocks" :blocks="contentBlocks || []" />
    <p v-if="redirectConfirmation">{{ t('formConfirmation') }}</p>
  </div>
</template>
